module.exports = __webpack_public_path__ + "img/help16.36bc5d1e.png";